import "regenerator-runtime/runtime.js";

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.promise.js";
import React, { useState, useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { dateFormat, ROLES, rolesTypesName } from 'enums';
import { Row, Col, Paper, BackButton, Button, Icon, EmployeeDataForm, TwoFactorModal, useUser } from 'components';
import { showApiError } from 'utils';
import { getEmployee } from 'services';
import { list, headerLeftTitle, headerLeftId } from 'styles';
import { canApproveText } from './styles';
import { jsx as ___EmotionJSX } from "@emotion/react";

var EmployeeDetails = function EmployeeDetails(_ref) {
  var _location$state, _match$params, _employeeData$name, _employeeData$phone, _employeeData$email, _rolesTypesName$emplo, _employeeData$franchi, _employeeData$franchi2, _employeeData$offices, _employeeData$partner;

  var location = _ref.location,
      match = _ref.match,
      history = _ref.history;

  var _ref2 = (_location$state = location.state) !== null && _location$state !== void 0 ? _location$state : {},
      employee = _ref2.employee;

  var _ref3 = (_match$params = match.params) !== null && _match$params !== void 0 ? _match$params : {},
      employeeId = _ref3.employeeId;

  var _useUser = useUser(),
      roleAdditionalData = _useUser.roleAdditionalData;

  var _useState = useState(employee),
      _useState2 = _slicedToArray(_useState, 2),
      employeeData = _useState2[0],
      setEmployeeData = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      isEdit = _useState4[0],
      setIsEdit = _useState4[1];

  var twoFactorModalRef = useRef();
  useEffect(function () {
    fetchEmployee();
  }, []);

  var fetchEmployee = /*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$getEmployee, _yield$getEmployee2, res, err;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getEmployee(employeeId);

            case 2:
              _yield$getEmployee = _context.sent;
              _yield$getEmployee2 = _slicedToArray(_yield$getEmployee, 2);
              res = _yield$getEmployee2[0];
              err = _yield$getEmployee2[1];

              if (!err) {
                _context.next = 8;
                break;
              }

              return _context.abrupt("return", showApiError(err));

            case 8:
              setEmployeeData(res);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function fetchEmployee() {
      return _ref4.apply(this, arguments);
    };
  }();

  var handleUpdate = function handleUpdate(data) {
    setEmployeeData(data);
    setIsEdit(false);
  };

  var handleClose = function handleClose() {
    return setIsEdit(false);
  };

  return ___EmotionJSX(React.Fragment, null, ___EmotionJSX(Row, {
    backgroundColor: "white",
    padding: "2em",
    className: "container"
  }, ___EmotionJSX(Col, {
    sm: "auto",
    position: "relative",
    margin: "0 0 1.4em"
  }, ___EmotionJSX(BackButton, {
    onBack: function onBack() {
      return history.push('/employee');
    }
  }), ___EmotionJSX("h6", {
    css: headerLeftTitle
  }, "ID: ", employeeData === null || employeeData === void 0 ? void 0 : employeeData.id), ___EmotionJSX("div", {
    css: headerLeftId
  }, ___EmotionJSX("span", null, employeeData === null || employeeData === void 0 ? void 0 : employeeData.name)))), ___EmotionJSX(Row, {
    backgroundColor: "white",
    className: "container"
  }, ___EmotionJSX(Col, {
    sm: 12
  }, ___EmotionJSX(Paper, {
    header: function header(_ref5) {
      var css = _ref5.css;
      return ___EmotionJSX("div", {
        css: css
      }, ___EmotionJSX("h5", null, "\u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u0437\u0430 \u0441\u043B\u0443\u0436\u0438\u0442\u0435\u043B\u044F"), !isEdit && ___EmotionJSX(React.Fragment, null, (roleAdditionalData === null || roleAdditionalData === void 0 ? void 0 : roleAdditionalData.isAdminOrTenant) && ___EmotionJSX(Button, {
        small: true,
        type: "info",
        margin: "0 1em 0 0",
        onClick: function onClick() {
          var _twoFactorModalRef$cu;

          return (_twoFactorModalRef$cu = twoFactorModalRef.current) === null || _twoFactorModalRef$cu === void 0 ? void 0 : _twoFactorModalRef$cu.open();
        }
      }, ___EmotionJSX(Icon, {
        iconName: "las la-lock",
        size: 14,
        margin: "0 0.3em 0 0"
      }), employeeData !== null && employeeData !== void 0 && employeeData.two_factor_enabled ? 'Преиздай двуфакторна автентикация' : 'Добави двуфакторна автентикация'), ___EmotionJSX(Button, {
        small: true,
        onClick: function onClick() {
          return setIsEdit(function (prev) {
            return !prev;
          });
        },
        leftIcon: {
          iconName: 'la la-pen',
          size: 18
        }
      }, "\u0420\u0435\u0434\u0430\u043A\u0442\u0438\u0440\u0430\u0439")));
    },
    margin: "0 0 2em 0"
  }, isEdit ? ___EmotionJSX(EmployeeDataForm, {
    data: employeeData,
    onSubmit: handleUpdate,
    onClose: handleClose
  }) : ___EmotionJSX("div", {
    css: list
  }, ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0418\u043C\u0435"), ___EmotionJSX("p", {
    className: "value"
  }, (_employeeData$name = employeeData === null || employeeData === void 0 ? void 0 : employeeData.name) !== null && _employeeData$name !== void 0 ? _employeeData$name : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0422\u0435\u043B\u0435\u0444\u043E\u043D"), ___EmotionJSX("p", {
    className: "value"
  }, (_employeeData$phone = employeeData === null || employeeData === void 0 ? void 0 : employeeData.phone) !== null && _employeeData$phone !== void 0 ? _employeeData$phone : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0418\u043C\u0435\u0439\u043B"), ___EmotionJSX("p", {
    className: "value"
  }, (_employeeData$email = employeeData === null || employeeData === void 0 ? void 0 : employeeData.email) !== null && _employeeData$email !== void 0 ? _employeeData$email : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0420\u043E\u043B\u044F"), ___EmotionJSX("p", {
    className: "value"
  }, (_rolesTypesName$emplo = rolesTypesName[employeeData === null || employeeData === void 0 ? void 0 : employeeData.user_role]) !== null && _rolesTypesName$emplo !== void 0 ? _rolesTypesName$emplo : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041A\u0440\u0435\u0434\u0438\u0442\u0435\u043D \u043F\u043E\u0441\u0440\u0435\u0434\u043D\u0438\u043A"), ___EmotionJSX("p", {
    className: "value"
  }, (_employeeData$franchi = employeeData === null || employeeData === void 0 ? void 0 : (_employeeData$franchi2 = employeeData.franchisee) === null || _employeeData$franchi2 === void 0 ? void 0 : _employeeData$franchi2.name) !== null && _employeeData$franchi !== void 0 ? _employeeData$franchi : '--')), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041E\u0444\u0438\u0441\u0438"), ___EmotionJSX("div", null, employeeData === null || employeeData === void 0 ? void 0 : (_employeeData$offices = employeeData.offices) === null || _employeeData$offices === void 0 ? void 0 : _employeeData$offices.map(function (el) {
    var _el$name;

    return ___EmotionJSX("p", {
      key: el === null || el === void 0 ? void 0 : el.id,
      className: "value"
    }, (_el$name = el === null || el === void 0 ? void 0 : el.name) !== null && _el$name !== void 0 ? _el$name : '--');
  }))), (employeeData === null || employeeData === void 0 ? void 0 : employeeData.user_role) === ROLES.partner && ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041F\u0430\u0440\u0442\u043D\u044C\u043E\u0440\u0438, \u043A\u044A\u043C \u043A\u043E\u0438\u0442\u043E \u0440\u0430\u0431\u043E\u0442\u0438"), ___EmotionJSX("div", null, employeeData === null || employeeData === void 0 ? void 0 : (_employeeData$partner = employeeData.partners) === null || _employeeData$partner === void 0 ? void 0 : _employeeData$partner.map(function (el) {
    var _el$name2;

    return ___EmotionJSX("p", {
      key: el === null || el === void 0 ? void 0 : el.id,
      className: "value"
    }, (_el$name2 = el === null || el === void 0 ? void 0 : el.name) !== null && _el$name2 !== void 0 ? _el$name2 : '--');
  }))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u041F\u0440\u0430\u0432\u0430 \u0437\u0430 \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0435"), ___EmotionJSX("p", {
    className: "value"
  }, ___EmotionJSX("span", {
    css: canApproveText(employeeData === null || employeeData === void 0 ? void 0 : employeeData.can_approve)
  }, employeeData !== null && employeeData !== void 0 && employeeData.can_approve ? 'ДА' : 'НЕ'))), ___EmotionJSX("div", {
    className: "list-Item"
  }, ___EmotionJSX("p", null, "\u0421\u044A\u0437\u0434\u0430\u0434\u0435\u043D \u043D\u0430"), ___EmotionJSX("p", {
    className: "value"
  }, moment(employeeData === null || employeeData === void 0 ? void 0 : employeeData.created_at).isValid() ? moment(employeeData === null || employeeData === void 0 ? void 0 : employeeData.created_at).format(dateFormat) : 'N/A')))))), ___EmotionJSX(TwoFactorModal, {
    modalRef: twoFactorModalRef,
    userId: employeeId
  }));
};

EmployeeDetails.propTypes = {
  location: PropTypes.object,
  match: PropTypes.object,
  history: PropTypes.object
};
export default EmployeeDetails;